import { CLOUDPAYMENTS_ERROR_MESSAGES, CLOUDPAYMENTS_ERROR_STATUS_CODES } from '../consts';

/** CloudTips may prefix codes with "R" (e.g. R5051); CloudPayments uses numeric ReasonCode. */
export const normalizeCloudPaymentsErrorCode = (errorCode: string | number): string => {
  return String(errorCode).trim().replace(/^R/i, '');
};

export const getCloudPaymentsErrorMessage = (
  errorCode: string | number | null | undefined,
): string | undefined => {
  if (errorCode === null || errorCode === undefined || errorCode === '') {
    return undefined;
  }

  const normalizedCode = normalizeCloudPaymentsErrorCode(errorCode);
  return CLOUDPAYMENTS_ERROR_MESSAGES[normalizedCode];
};

export const getCloudPaymentsErrorStatusCode = (
  errorCode: string | number | null | undefined,
): number | undefined => {
  if (errorCode === null || errorCode === undefined || errorCode === '') {
    return undefined;
  }

  const normalizedCode = normalizeCloudPaymentsErrorCode(errorCode);
  return CLOUDPAYMENTS_ERROR_STATUS_CODES[normalizedCode];
};

export const resolveCloudPaymentsResponseErrorsMessage = (
  errors?: string[],
  fallbackMessage = 'Оплата не удалась',
): string => {
  const firstErrorCode = errors?.[0];

  if (!firstErrorCode) {
    return fallbackMessage;
  }

  return getCloudPaymentsErrorMessage(firstErrorCode) ?? firstErrorCode;
};
